import { EntityFacadeService } from "../../../shared/store/entity-store/entity-facade.service";
import { WidgetData, WidgetType } from "../models/dashboard.model";
import { EntityStoreState } from "../../../shared/store/store-types.model";
import { WidgetDataApiService } from "../services/widget-data-api.service";
import { Injectable, signal } from "@angular/core";
import { firstValueFrom } from "rxjs";
import {
  Untrack,
  UpdateStatus,
} from "../../../shared/store/utils/store-utils.service";

@Injectable({
  providedIn: "root",
})
export class WidgetDataFacadeService extends EntityFacadeService<
  WidgetData,
  WidgetDataApiService,
  EntityStoreState
> {
  /** Tick incrémenté à chaque "actualiser" — déclenche le re-fetch dans les widgets. */
  refreshTick = signal(0);

  constructor(private widgetApiService: WidgetDataApiService) {
    super(widgetApiService);
    window["widget"] = this;
  }

  /**
   * Vide le cache widget côté back puis purge le store local et incrémente
   * `refreshTick` — les widgets qui s'y abonnent rappellent `loadOne(type)`.
   */
  @Untrack
  @UpdateStatus
  async refreshAll() {
    await firstValueFrom(this.widgetApiService.refreshAll());
    // Vide le store front : les widgets verront `getById()` revenir undefined
    // puis se re-loaderont via leur effect/computed habituel.
    for (const id of this.getAllEntities()()?.map((w) => w.id) ?? []) {
      this.store.removeOne(id as WidgetType);
    }
    this.refreshTick.update((v) => v + 1);
  }

  /**
   * Rafraîchissement léger : ne vide PAS le cache back (pas de
   * `POST /widget/refresh`) et ne purge pas le store — incrémente juste
   * `refreshTick` pour que chaque widget re-GET ses données. Les GET sont
   * servis depuis le cache back (TTL 5 min) ou recalculés à la volée si une
   * mutation a invalidé le type (cf. `invalidateWidgetCache` côté back).
   * Utilisé par l'auto-refresh du dashboard tant que l'onglet est visible.
   */
  softRefresh() {
    this.refreshTick.update((v) => v + 1);
  }
}
